import { useEffect, useRef } from "react";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    // Preserve the redirect target chosen when SSO was initiated (Emergent brings us back to
    // whatever path we set as `redirect`, e.g. /dashboard or /menu). Fall back to /menu.
    const target = window.location.pathname && window.location.pathname !== "/" ? window.location.pathname : "/menu";
    (async () => {
      try {
        await api.post("/auth/session", { session_id: sessionId });
        window.location.href = target;
      } catch (e) {
        const status = e.response?.status;
        const msg = e.response?.data?.detail;
        if (status === 403 && msg) {
          window.location.href = `/?auth_error=${encodeURIComponent(msg)}`;
        } else {
          window.location.href = "/";
        }
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="font-mono-c text-sm" style={{ color: "var(--muted)" }}>
        Menyiapkan akun kantormu...
      </p>
    </div>
  );
}
